import { useDispatchThunk } from "@common/redux/dispatchThunk";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { changeQueryFilters, setTags, overviewsSlice } from "@common/redux/slices/entities.slice";
import { ITag } from "@common/redux/types/tags";
import { FilterTags } from "@kursk/components/ui/FilterTags/FilterTags";
import { useDispatch } from "react-redux";

export function Filters() {
  const dispatch = useDispatch();
  const dispatchThunk = useDispatchThunk();
  const { meta, filters } = useSelectSlice(overviewsSlice);

  const onTagClick = async (tag: ITag) => {
    dispatch(setTags('overviews', tag));
    await dispatchThunk(changeQueryFilters('overviews'));
  }

  return (
    <>
      <FilterTags
        selected={filters?.allTags}
        tags={meta?.tags}
        onTagClick={onTagClick}
      />
    </>
  );
}
